import axios from "axios";
import { API } from "../config/AppConfig";
import { UPLOAD_CHART, SUBMIT_UPLOADED_CHART, DELETE_CHART, UPLOAD_PAYOR_CONTRACT, SUBMIT_PAYOR_CONTRACT, GET_PAYOR_CONTRACT, DELETE_PAYOR_CONTRACT } from "../constants/Endpoints";
import { ACCESS_TOKEN } from "../constants/PreferenceKeys";
import { whichTokenToUse } from "../utils/isManagerCreatedToken";

class PayorContractRepository {

  async uploadCharts(formData, onUploadProgress) {
    const token = localStorage.getItem(whichTokenToUse())
    const response = await axios.post(
      UPLOAD_CHART,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    // const response = await API.post(UPLOAD_CHART, {
    //   body: payload
    // });
    return response;
  }

  async submitUploadedCharts(formData) {
    const response = await API.post(SUBMIT_UPLOADED_CHART, { body: formData })
    return response;
  }
  async deleteChart(fileId) {
    const response = await API.delete(DELETE_CHART, {
      pathParams: { fileId }
    });
    return response;
  }
  
  async uploadPayorContracts(formData, onUploadProgress) {
    const token = localStorage.getItem(whichTokenToUse())
    const response = await axios.post(
      UPLOAD_PAYOR_CONTRACT,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    return response;
  }

  async submitUploadedPayorContracts(formData) {
    const response = await API.post(SUBMIT_PAYOR_CONTRACT, { body: formData })
    return response;
  }

  async getUploadedPayorContract () {
    const response = await API.get(GET_PAYOR_CONTRACT);
    return response;
  }

  async deletepayorContract(fileId) {
    const response = await API.delete(DELETE_PAYOR_CONTRACT, {
      pathParams: { fileId }
    });
    return response;
  }
}

const payorContractsRepository = new PayorContractRepository();
export default payorContractsRepository;